<template>
  <header :class="className">
    <h1 class="header__title">
      <slot name="title"></slot>
    </h1>
    <div class="header__lead">
      <TextBlock type="lead" class="header__lead-text" v-html="text">
        <slot></slot> 
      </TextBlock>
    </div>
  </header>
</template>
<script>

import TextBlock from '@/components/text/Default';

export default {
  props: [ 'type', 'text'],
  components: {
    TextBlock
  },
  computed: {
    className() {
      return this.type ? `header--${ this.type }` : 'header';
    }
  }
}
</script>
<style lang="scss" scoped>
.header {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0 24px;
  @media screen and (max-width: $sp_point) {
    width: auto;
    padding: 0 16px 24px;
  }
}
.header--finish {
  @extend.header;
  padding-bottom: 0;
  .header__title {
    font-size: 2.2rem;
  }
  .header__lead-text{
    border: 0;
    text-align: center;
    font-size: 1.8rem;
    padding-top: 0;
  }
}
.header__title {
  @include text-crop;
    display: block;
    font-weight: bold;
    font-size: 2.6rem;
    font-feature-settings: "palt";
  @media screen and (max-width: $sp_point) {
    line-height: 1.5;
    font-size: 2.2rem;
    text-align: center;
  }
}
.header__lead {
  padding-top: 40px;
  width: 100%;
  text-align: center;
  @media screen and (max-width: $sp_point) {
    padding-top: 10px;
    text-align: left;
  }
}
.header__lead-text {
    text-align: left;
  &:empty {
    display: none;
  }
}
</style>